import React, { useEffect, useState } from "react";
import axios from "axios";
import winEmblem from './../../assets/images/WinRpundedLogo-pink.png';
import moreArrow from './../../assets/images/rightArrow.png';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../Security/ErrorModal";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';

export const RX_Authorization = () => {
  const [authorizationData, setAuthorizationData] = useState([]);
  const { t, i18n } = useTranslation();
  const token = localStorage.getItem('AccessToken'); // Assuming the token is stored in localStorage
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [selectedAuthDetail, setSelectedAuthDetail] = useState(null);
  const userInfo = useSelector((state) => state.userData);
  const navigate = useNavigate();
  const contract = useSelector((state) => state.userData);

  const userTypePremier = contract.userData.Premiere;

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log(userInfo)
    const fetchRXAuthorization = async () => {
      setLoading(true);
      try {
        const params = {
          MemberID: userInfo.userData.MemberID,
          Contract: userInfo.userData.ContractIdentified,
          EmailID: userInfo.userData.EmailID,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };
        const response = await axios.post(
          Endpoints.LoadRxOnlyAuthorizations,
          { _Params: JSON.stringify(params) },
          
            {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Connection": "close",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          setAuthorizationData(response.data);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } catch (error) {
        console.error("Error fetching RX Authorization data:", error);
      }  finally {
      setLoading(false); // <-- Ensure loading is set to false after fetch
    }
    };

    fetchRXAuthorization();
  }, [token]);

  const confirmNavigation = () => {
    setShowModal(false);
    navigate("/review-rx", { state: { authorizationDetail: selectedAuthDetail } });
  };

  // Navigate to RX_Review with different states based on AuthStatus
  const handleItemClick = (auth) => {
    if (auth.AuthStatus === "Pended") {
      //navigate('/review-rx', { state: { authorizationDetail: auth} });
      setModalMessage("Please check medication boxes for expiration dates and keep in mind that any multi-dose vials that are punctured are generally only good for 28 days or as otherwise noted on the vial itself.");
      setSelectedAuthDetail(auth);
      setShowModal(true);
    } else {
      navigate('/rx-review', { state: { authorizationDetail: auth} });
    }
  };
    const handleBackClick = () => {
      navigate(-1); // Go back to the previous page
    };

    const handleRefillClick = (auth) => {
      navigate('/refills-required', { state: { authorizationDetail: auth } });
    };
    if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>

      {isHighmarkPortal ? 
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>
            </span>
          </button>       
          <h2 className="page-heading">{t('rxAuthorization')}</h2>
        </div>:
        <div className="col-md-12 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
            <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
            </span>
          </button>       
          <h2 className="page-heading">{t('rxAuthorization')}</h2>
        </div>
      }
      {/* Add informational text below the heading */}
<div className="col-md-12 mt-0">
    <p>Your current authorizations are listed below. Please note, an authorization request is required for all individual fertility prescriptions.</p>
    <p >
      Don’t see your prescription or any refills listed below? Please request a new authorization – our team will work to ensure you’re covered!
    </p>
</div>
<div className="col-md-12 mt-1">
 <button
                className="win-btn-primary-w-content mobile-view me-3"
                onClick={() => navigate('/new-authorization')}
              >
                Request a new authorization
              </button>
</div>

      <div className="col-md-12 mt-5 d-md-flex flex-wrap rx-auth-wrapper">
        {authorizationData.length > 0 ? (
          authorizationData.map((auth, index) => (
            <div className="rx-auth-block-wrapper" key={index}
            onClick={() => handleItemClick(auth)}
            >
              <div className="rx-auth-block-win-emblem">
                <img src={winEmblem} alt="WIN Logo" />
              </div>
              <div className="rx-auth-block-content-wrapper">
                <h4 className="page-heading-secondary-black">
                  {auth.PharmacyName || "Pharmacy Name Not Available"}
                </h4>
                <p>
                  <span>{auth.AuthNo || "Auth Number Not Available"}</span>
                  <span>
                    {auth.AuthRange || "Start Date Not Available"}
                    
                  </span>
                  {userTypePremier === "Yes" && (
                  <>
                    <span>
                  {t('totalTreatmentCost')} - $
                    {auth.EstimatedCost || t('notAvailable')}
                  </span>
                  <span>
                  {t('estimatedCostShare')} - $
                    {auth.EstimatedCostShare || t('notAvailable')}
                  </span>
                  </>
                  )}
                </p>
                <span
                  className={`rx-auth-status me-2 ${
                    auth.AuthStatus === "Approved"
                      ? "Approved"
                      : auth.AuthStatus === "Processing"
                      ? "processing"
                      : "rejected"
                  }`}
                >
                  {auth.AuthStatus || "Status Not Available"}
                </span>
                <span
                  className={`rx-auth-status-bar-on-left ${
                    auth.AuthStatus === "Approved"
                      ? "approved"
                      : auth.AuthStatus === "Processing"
                      ? "processing"
                      : "rejected"
                  }`}
                >
                </span>
                {/* Show Refill Button if Status is Approved and RefillsAvailable exists */}
                {auth.AuthStatus === "Approved" && auth.RefillsAvailable ==="Yes" && (
                  <span  className={`rx-auth-status ${auth.AuthStatus === "Approved" ? "Approved" : "Approved"}`}>
                    {t('refillAvailable')}
                  </span>
                )}
              </div>
              <div className="rx-auth-block-more-arrow">
                <img src={moreArrow} alt="More" />
              </div>
            </div>
          ))
        ) : (
          <>
            <div className="no-data-available flex-column">
                <div className="d-flex text-center">{t('noRxAuthorizationData')}</div>              
            </div>
          </>
        )}
      </div>
      <ErrorModal show={showModal} message={modalMessage} onClose={() => setShowModal(false)} isPendedStatusSelected={true} onOkay={confirmNavigation}/>
    </>
  );
};

export default RX_Authorization;
